import { ENV } from '../../config/runtimeEnv';
import { http } from "../../lib/http/client";
import type { Dayjs } from "dayjs";
const API_BASE_URL = ENV.VITE_LABIQ_SERVER;


/////////////////////////////////////////////////// Auth sample endpoints

export const createAuthSamples = async (userEmail: string, sampleId: string) => {
    try {
        const response = await http.post(
            `${API_BASE_URL}/authSamples`,
            {
                auth_login: userEmail,
                sampleID: sampleId,
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Error creating application: ${error}`);
    }
};

export const updateAuthSampleDeactivationDate = async (authSampleId: number, date: Dayjs) => {
    try {
        const response = await http.put(
            `${API_BASE_URL}/authSamples/deactivateDate/${authSampleId}`,
            {
                // A calendar day: toISOString() gave the UTC day, one day early in Australia.
                deactivation_date: date.format("YYYY-MM-DD"),
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Error creating application: ${error}`);
    }
};

export const getAuthSampleDeactivationDate = async (authSampleId: number,) => {
    try {
        const response = await http.get(
            `${API_BASE_URL}/authSamples/deactivateDate/${authSampleId}`
        );
        return response.data.data;
    } catch (error) {
        throw new Error(`Error getting sample deactivaiton date: ${error}`);
    }
};

export const fetchPatientAuthSamples = async (patientEmail: string) => {
    const response = await http.get(`${API_BASE_URL}/authSamples/user/${patientEmail}`);
    return response.data.data;
};

export const removePatientAuthSamples = async (authSampleId: number) => {
    const response = await http.delete(`${API_BASE_URL}/authSamples/${authSampleId}`);
    return response.data;
};

export const deactivatePatientAuthSamples = async (authSampleId: number) => {
    const response = await http.put(`${API_BASE_URL}/authSamples/deactivate/${authSampleId}`, {});
    return response.data;
};

export const activatePatientAuthSamples = async (authSampleId: number) => {
		console.log("Activating auth sample with ID:", authSampleId);
    const response = await http.put(`${API_BASE_URL}/authSamples/activate/${authSampleId}`, {});
    return response.data;
};
